export class StorageAdapter {
  constructor(
    private readonly namespace = "",
    private readonly engine: Storage
  ) {}

  private _key(key: string) {
    return [this.namespace, key].filter(Boolean).join(".");
  }

  private _serialize(value: any) {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return value;
    }
  }

  private _deserialize(value: any) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  get<T = string>(key: string, defaultValue?: T): T {
    const val = this.engine.getItem(this._key(key)) ?? defaultValue;
    return this._deserialize(val);
  }

  set<T = string>(key: string, value: T): void {
    return this.engine.setItem(this._key(key), this._serialize(value));
  }

  del(key: string): void {
    this.engine.removeItem(this._key(key));
  }

  clear(): void {
    this.engine.clear();
  }
}

/**
 * In-memory storage implementation of the Storage interface
 */
export class MemoryStorage implements Storage {
  private store = new Map<string, any>();

  get length() {
    return Object.keys(this.store).length;
  }

  clear() {
    this.store = new Map<string, any>();
  }

  getItem(key: string) {
    return this.store.get(key) ?? null;
  }

  key(index: number) {
    return [...this.store.keys()][index] ?? null;
  }

  removeItem(key: string) {
    this.store.delete(key);
  }

  setItem(key: string, value: string) {
    this.store.set(key, value);
  }
}
